import { render, staticRenderFns } from "./ImageNews.vue?vue&type=template&id=18d13dda&scoped=true"
import script from "./ImageNews.vue?vue&type=script&lang=js"
export * from "./ImageNews.vue?vue&type=script&lang=js"
import style0 from "./ImageNews.vue?vue&type=style&index=0&id=18d13dda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d13dda",
  null
  
)

export default component.exports